<template>
  <v-tooltip :disabled="$vuetify.breakpoint.xsOnly" bottom>
    <template #activator="{ on }">
      <v-btn id="notification_btn" icon v-on="on" @click="openDrawer">
        <v-badge :value="count" overlap :color="badgeColor" :content="count">
          <v-icon>notifications</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <span>{{ $tc('notification', 2) }}</span>
  </v-tooltip>
</template>

<script>
const INFO_TYPE = 0
const ATENTION_TYPE = 1
const CAUTION_TYPE = 2
const CRITICAL_TYPE = 3
export default {
  computed: {
    warnings () {
      return this.$store.getters['warning/getWarnings']
    },
    count () {
      return this.warnings.length
    },
    badgeColor () {
      if (this.warnings && this.warnings.length > 0) {
        const listOfTypes = this.warnings.map(warning => {
          return warning.type
        })
        if (listOfTypes.includes(CRITICAL_TYPE)) return 'red'
        else if (listOfTypes.includes(CAUTION_TYPE)) return 'orange'
        else if (listOfTypes.includes(ATENTION_TYPE)) return 'yellow'
        else if (listOfTypes.includes(INFO_TYPE)) return 'blue'
      }
      return 'green'
    }
  },
  methods: {
    openDrawer () {
      this.loadWarnings()
      this.$emit('click')
    },
    loadWarnings () {
      this.$store.dispatch('warning/load')
    }
  }
}
</script>
